// Human-readable labels for the AI/search crawler user-agents the backend
// recognizes. Shared between Settings and audit Fix modals.
export const BOT_LABELS = {
  GPTBot: 'GPTBot (OpenAI / ChatGPT)',
  'ChatGPT-User': 'ChatGPT-User (live browsing)',
  ClaudeBot: 'ClaudeBot (Anthropic)',
  'anthropic-ai': 'anthropic-ai (legacy)',
  PerplexityBot: 'PerplexityBot',
  'Perplexity-User': 'Perplexity-User',
  Googlebot: 'Googlebot (Search)',
  'Google-Extended': 'Google-Extended (Gemini training)',
  Applebot: 'Applebot (Apple Intelligence)',
  'cohere-ai': 'cohere-ai',
  CCBot: 'CCBot (Common Crawl)',
  facebookexternalhit: 'facebookexternalhit (Meta)',
  Bytespider: 'Bytespider (ByteDance)',
};
